import { useContext } from 'react';
import { StyleContext } from '../../providers/StyleContextProvider';
import { Candidate } from '../../models/Candidate';
import { Sector } from '../../models/Sector';

interface Props {
    selectedCandidate: Candidate;
    preferredSectors: Sector[];
}

export const InfoTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("candidatePoolTabs");
    const styles = tabStyles.infoTab;

    return (
        <>
            <p style={styles.title}>Info</p>
            <div style={styles.details}>
                {props.selectedCandidate?.linkedInUrl && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"LinkedIn Url"}</div>
                    <div style={styles.details.text}>{props.selectedCandidate.linkedInUrl}</div>
                </div>}
                <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Preferred Sectors"}</div>
                    <div style={{...styles.details.text, ...(styles.details.text.maxWidth)}}>
                        {props.preferredSectors && props.preferredSectors.length > 0 && props.preferredSectors.map((sector, index) => (
                            <div key={index} style={styles.details.sector}>{sector.sectorName}</div>
                        ))}
                    </div>
                </div>
                {props.selectedCandidate?.additionalQualifications && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Qualifications"}</div>
                    <div style={{...styles.details.text, ...(styles.details.text.maxWidth)}}>{props.selectedCandidate.additionalQualifications}</div>
                </div>}
            </div>
        </>
    );
}